import moment from "moment";
import { message } from "antd";
import { useState, useEffect, useReducer } from "react";
import messages from "../../../../errors/messages.en-IN.json";

export const CheckoutTotalManualDiscount = async (
  pricingRule,
  setCart,
  cart,
  orderType,
  cartObj,
  discountInput,
  matchingApproval,
  iscoupon,
  couponInput,
  uniqReferenceId,
  mPricingCouponId,
  mPricingRulesId
) => {
  const saleTypeValidation = pricingRule.cwrSaletypeId === null ? true : pricingRule.cwrSaletypeId === orderType.cwrSaletype.cwrSaletypeId;
  const tillData = JSON.parse(localStorage.getItem("tillData"));
  const saleTypeData = JSON.parse(localStorage.getItem("saleTypeData")) || {};
  let taxIncludeFlag = saleTypeData?.customer?.istaxincluded === "Y" ? "Y" : tillData.tillAccess.csBunit.isTaxIncluded ? tillData.tillAccess.csBunit.isTaxIncluded : "Y";
  const billCart = { ...cartObj };
  const precision = tillData?.tillAccess?.csBunit?.currencies[0]?.prcPrecision || 2;
  let nonReturnItemsTotal = 0;
  let nonReturnItemsQty = 0;
  let nonReturnItemsDiscount = 0;
  let nonReturnItems = [];
  billCart.items.map((item) => {
    if (!item.isReturn && item.isCanceled !== "Y") {
      nonReturnItemsTotal += item.nettotal;
      nonReturnItemsQty += item.weight;
      nonReturnItemsDiscount += item.discount;
      nonReturnItems.push(item);
    }
  });

  let maxAmount = pricingRule.maxBillAmount ? Math.abs(nonReturnItemsTotal) <= pricingRule.maxBillAmount : true;
  const minQtyFlag = pricingRule.minimumQty ? Math.abs(nonReturnItemsQty) >= pricingRule.minimumQty : true;
  const maxQtyFlag = pricingRule.maximumQty ? Math.abs(nonReturnItemsQty) <= pricingRule.maximumQty : true;
  const minAmountFlag = pricingRule.billAmount ? Math.abs(nonReturnItemsTotal) >= pricingRule.billAmount : true;
  const maxAmountFlag = pricingRule.maxBillAmount ? Math.abs(nonReturnItemsTotal) <= pricingRule.maxBillAmount : true;
  let giftCardFlag = false;
  let uniqueFinalArray = [];

  nonReturnItems.forEach((addedToCart) => {
    let excludingFlag = true;

    if (addedToCart?.layAway === "Y" && addedToCart?.weight <= 0) {
      excludingFlag = false;
    }

    const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === addedToCart.mProductCategoryId);

    if (
      (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
      (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy) ||
      (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingProduct = pricingRule.mPricingXProducts.find((pc) => pc.mProductId === addedToCart.productId);

    if (
      (pricingRule.excludeProducts === "Y" && matchingProduct) ||
      (pricingRule.excludeProducts !== "Y" && !matchingProduct) ||
      (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
    ) {
      excludingFlag = false;
    }

    const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === addedToCart.productBrandId);

    if (
      (pricingRule.excludeBrands === "Y" && matchingBrand) ||
      (pricingRule.excludeBrands !== "Y" && !matchingBrand) ||
      (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
    ) {
      excludingFlag = false;
    }
    if (excludingFlag) uniqueFinalArray.push(addedToCart);
  });

  let totalBillPrice = 0;
  let validBillAmount = 0;
  uniqueFinalArray.map((product) => {
    if (product?.priority ? product?.priority <= pricingRule.priority || pricingRule.mPricingrulesId === product.mPricingruleId : true) {
      totalBillPrice = totalBillPrice + parseFloat(product.realPrice * Math.abs(product.weight) - product.discount);
    }
    validBillAmount = validBillAmount + parseFloat(product.realPrice * Math.abs(product.weight));
  });

  if (totalBillPrice - discountInput < 0 && pricingRule.discountType === "V" && billCart.items.length > 0) {
    message.error(`${messages.errors.discounts.amount_exceeds_total}`);
    return cartObj;
  }
  let discountedAmount = ((totalBillPrice + cart.discount) * discountInput) / 100;
  if (cart.total + cart.discount - discountedAmount < 0 && pricingRule.discountType === "P" && billCart.items.length > 0) {
    message.error(`${messages.errors.discounts.amount_exceeds_total}`);
    return cartObj;
  }

  if (validBillAmount <= discountInput && billCart.items.length > 0) {
    message.error(`${messages.errors.discounts.amount_exceeds_total}`);
    return cartObj;
  }

  if (
    Math.abs(nonReturnItemsTotal) + Math.abs(nonReturnItemsDiscount) >= pricingRule.billAmount &&
    maxAmount &&
    minQtyFlag &&
    maxQtyFlag &&
    minAmountFlag &&
    maxAmountFlag &&
    validBillAmount >= pricingRule.billAmount &&
    !giftCardFlag &&
    discountInput <= validBillAmount
  ) {
    let discountValue = 0;
    discountValue = pricingRule.discountType === "V" ? discountInput : (discountInput / 100) * nonReturnItemsTotal;
    let discountType = pricingRule.discountType === "V" ? "FD" : "PD";
    if (pricingRule.issueGiftVoucher === "N" || pricingRule.issueGiftVoucher === null) {
      const cartItemsFiltered = billCart.items.filter((i) => i.nextRule === "Y" || i.nextRule === undefined);
      let salePricesTotal = 0;
      for (let i = 0; i < cartItemsFiltered.length; i += 1) {
        salePricesTotal += parseFloat(cartItemsFiltered[i].realPrice * cartItemsFiltered[i].weight);
      }
      let discountFlag = false;
      let totalAppliedDiscount = 0;

      // Helper function to apply discount to an item (parent or child)
      const applyDiscountToItem = (item, index, itemsArray, parentDiscount = null, childrenTotalPrice = null) => {
        if (item.isCanceled === "Y") return;
        let excludingFlag = true;

        if (item?.layAway === "Y" && item?.weight <= 0) {
          excludingFlag = false;
        }
        if (pricingRule.mPricingB2CCustomerSegments.length > 0) {
          const matchingCustomerSegment = pricingRule.mPricingB2CCustomerSegments.find(
            (pc) => pc.cwrB2CCustomerSegmentId === cartObj.customer?.b2cCustomerSegment?.cwrB2CCustomerSegmentId
          );

          if (
            (pricingRule.excludeB2CSegment === "Y" && matchingCustomerSegment) ||
            (pricingRule.excludeB2CSegment !== "Y" && !matchingCustomerSegment) ||
            (pricingRule.excludeB2CSegment === "N" && pricingRule.mPricingB2CCustomerSegments.length === 0)
          ) {
            excludingFlag = false;
          }
        }

        if (pricingRule.mPricingB2CCustomers.length > 0) {
          const matchingCustomer = pricingRule.mPricingB2CCustomers.find((pc) => pc.b2cCustomerId === cartObj.customer.cwrCustomerId);

          if (
            (pricingRule.excludeB2CCustomers === "Y" && matchingCustomer) ||
            (pricingRule.excludeB2CCustomers !== "Y" && !matchingCustomer) ||
            (pricingRule.excludeB2CCustomers === "N" && pricingRule.mPricingB2CCustomers.length === 0)
          ) {
            excludingFlag = false;
          }
        }

        const matchingCategoy = pricingRule.mPricingPcategories.find((pc) => pc.mProductCategoryId === item.mProductCategoryId);

        if (
          (pricingRule.excludeProductCategories === "Y" && matchingCategoy) ||
          (pricingRule.excludeProductCategories !== "Y" && !matchingCategoy) ||
          (pricingRule.excludeProductCategories === "N" && pricingRule.mPricingPcategories.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingProduct = pricingRule.mPricingXProducts.find((pc) => pc.mProductId === item.productId);

        if (
          (pricingRule.excludeProducts === "Y" && matchingProduct) ||
          (pricingRule.excludeProducts !== "Y" && !matchingProduct) ||
          (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingBrand = pricingRule.mPricingBrands.find((pc) => pc.mBrandId === item.productBrandId);

        if (
          (pricingRule.excludeBrands === "Y" && matchingBrand) ||
          (pricingRule.excludeBrands !== "Y" && !matchingBrand) ||
          (pricingRule.excludeBrands === "N" && pricingRule.mPricingBrands.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingBusinessUnit = pricingRule.mPricingBUnits.find((pc) => pc.mBunitPricingId === tillData.tillAccess.csBunit.csBunitId);
        if (
          (pricingRule.excludeBusinessUnits === "Y" && matchingBusinessUnit) ||
          (pricingRule.excludeBusinessUnits !== "Y" && !matchingBusinessUnit) ||
          (pricingRule.excludeBusinessUnits === "N" && pricingRule.mPricingBUnits.length === 0)
        ) {
          excludingFlag = false;
        }

        const matchingProductIndex = pricingRule.mPricingXProducts.findIndex((op) => op.mProductId === item.productId);

        if (
          (pricingRule.excludeProducts === "Y" && matchingProductIndex !== -1) ||
          (pricingRule.excludeProducts !== "Y" && matchingProductIndex === -1) ||
          (pricingRule.excludeProducts === "N" && pricingRule.mPricingXProducts.length === 0)
        ) {
          excludingFlag = false;
        }

        let pricingRuleFlag = true;

        if (item.discount <= 0) {
          const matchingProduct = pricingRule.mPricingXProducts.find((res) => res.mProductId === item.productId);
          if (matchingProduct) {
            delete item.priority;
          }
        }

        if (pricingRuleFlag && excludingFlag && saleTypeValidation && !item.isReturn && (iscoupon ? (item?.priority ? item?.priority < pricingRule.priority : true) : true)) {
          let allDiscounts = item?.allDiscounts || [];
          let approvalData = item?.approval || [];
          let matchedRuleIndex = allDiscounts.findIndex((d) => d.mPricingruleId === pricingRule.mPricingrulesId);
          let matchedApprovalIndex = approvalData.findIndex((d) => d.mPricingrulesId === pricingRule.mPricingrulesId);

          let discountAmt;
          let sp;
          if (parentDiscount !== null && childrenTotalPrice !== null) {
            // Child item: Distribute parent's discount proportionally
            if (discountType === "FD") {
              const childPrice = parseFloat(item.realPrice * item.weight);
              discountAmt = (childPrice / childrenTotalPrice) * parentDiscount;
              item.discount = discountAmt;
              const taxInclude = (item.realPrice * item.taxRate) / 100;
              sp = ((taxIncludeFlag === "Y" ? item.realPrice : item.realPrice + taxInclude) * item.weight || item.nettotal) - item.discount;
              const tax = sp - sp / (1 + item.taxRate / 100);
              totalAppliedDiscount += item.discount;
              item.taxAmount = tax;
              item.nettotal = sp;
            } else {
              const childTotal = parseFloat(item.realPrice) * item.weight;
              const discountAmt = (discountInput / 100) * childTotal;
              item.discount = discountAmt;

              const priceAfterDiscount = childTotal - discountAmt;
              let tax = 0;
              if (taxIncludeFlag === "Y") {
                tax = priceAfterDiscount - priceAfterDiscount / (1 + item.taxRate / 100);
                item.nettotal = priceAfterDiscount;
              } else {
                tax = (priceAfterDiscount * item.taxRate) / 100;
                item.nettotal = priceAfterDiscount + tax;
              }

              totalAppliedDiscount += discountAmt;
              item.taxAmount = tax;
            }
          } else if (discountType === "FD") {
            // Parent item with fixed discount
            discountAmt = discountInput * ((parseFloat(item.realPrice * item.weight) - item.discount) / totalBillPrice);
            item.discount = matchedRuleIndex !== -1 && allDiscounts.length === 1 ? discountAmt : discountAmt + item.discount;
            const taxInclude = (item.realPrice * item.taxRate) / 100;
            sp = ((taxIncludeFlag === "Y" ? item.realPrice : item.realPrice + taxInclude) * item.weight || item.nettotal) - item.discount;
            const tax = sp - sp / (1 + item.taxRate / 100);
            totalAppliedDiscount += item.discount;
            item.taxAmount = tax;
            item.nettotal = sp;
          } else {
            // Parent item with percentage discount
            discountAmt = (discountInput / 100) * parseFloat(item.realPrice);
            item.discount = discountAmt * item.weight;
            sp = parseFloat(item.realPrice) - discountAmt;
            const mrp = parseFloat(sp) * item.weight;
            const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + item.taxRate / 100) : (mrp * item.taxRate) / 100;
            totalAppliedDiscount += item.discount;
            item.taxAmount = tax;
            item.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
          }
          if (matchedRuleIndex === -1) {
            allDiscounts.push({
              mPricingruleId: pricingRule.mPricingrulesId,
              discountValue: discountValue,
              discountType: discountType,
            });
          }
          if (matchedApprovalIndex === -1) {
            approvalData.push({
              ...matchingApproval,
              time: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
              mPricingrulesId: pricingRule.mPricingrulesId,
            });
          }
          discountFlag = true;
          item.salePrice = sp;
          item.discountName = pricingRule.printedName;
          item.mPricingruleId = pricingRule.mPricingrulesId;
          item.iscoupon = iscoupon;
          item.couponInput = couponInput;
          item.referenceId = uniqReferenceId;
          item.mPricingCouponId = mPricingCouponId;
          item.priority = pricingRule.priority;
          item.allDiscounts = allDiscounts;
          item.nextRule = pricingRule.nextRule;
          item.approval = approvalData;
          itemsArray[index] = item;
        }
      };

      // Process each item and its children
      billCart.items.forEach((addedToCart, index) => {
        // Apply discount to the parent item
        applyDiscountToItem(addedToCart, index, billCart.items);

        // Process children if they exist
        if (addedToCart.children && Array.isArray(addedToCart.children)) {
          // Calculate total price of children before discount
          const childrenTotalPrice = addedToCart.children.reduce((sum, child) => sum + parseFloat(child.realPrice * child.weight), 0);

          // Distribute parent's discount to children
          addedToCart.children.forEach((child, childIndex) => {
            applyDiscountToItem(child, childIndex, addedToCart.children, addedToCart.discount, childrenTotalPrice);
          });

          // Calculate parent's nettotal as sum of its own nettotal and children's nettotal
          let childrenNetTotal = addedToCart.children.reduce((sum, child) => sum + (child.nettotal || 0), 0);
          addedToCart.nettotal = childrenNetTotal;

          let childrenDiscount = addedToCart.children.reduce((sum, child) => sum + (child.discount || 0), 0);
          addedToCart.discount = childrenDiscount;

          let childrenTaxAmount = addedToCart.children.reduce((sum, child) => sum + (child.taxAmount || 0), 0);
          addedToCart.taxAmount = childrenTaxAmount;
        }
      });

      billCart.mPricingruleId = pricingRule.mPricingrulesId;
      billCart.billDiscount = billCart.billDiscount ? billCart.billDiscount + discountValue : discountValue;

      const addedToCart = billCart.items;

      let totalTax = 0;
      let totalPrice = 0;
      let totalItemsQty = 0;
      let totalDiscounts = 0;

      // Calculate totals including children
      for (let i = 0; i < addedToCart.length; i += 1) {
        if (addedToCart[i].isCanceled === "Y") continue;
        totalPrice += addedToCart[i].nettotal;
        totalItemsQty += addedToCart[i].weight;
        totalTax += addedToCart[i].taxAmount;
        totalDiscounts += addedToCart[i].discount;
        // Include children's contributions
        if (addedToCart[i].children && Array.isArray(addedToCart[i].children)) {
          addedToCart[i].children.forEach((child) => {
            totalPrice += child.nettotal || 0;
            totalItemsQty += child.weight || 0;
            totalTax += child.taxAmount || 0;
            totalDiscounts += child.discount || 0;
          });
        }
        addedToCart[i].key = i;
      }
      const roundOffValue = Math.round(totalPrice);
      const totalRoundOff = totalPrice - roundOffValue;
      let couponsData = cart?.couponInput?.length > 0 ? [...cart?.couponInput] : [];

      if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null && discountFlag) {
        couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
      }

      let uniqueArray = cart?.manualDiscountData?.totalLevelDiscount || [];
      let lineLevelDiscounts = cart?.manualDiscountData?.lineLevelDiscount || [];
      let totalLevelDiscounts = cart?.manualDiscountData?.totalLevelDiscount || [];

      let allSequenceNos = [...lineLevelDiscounts.map((item) => item.sequenceNo), ...totalLevelDiscounts.map((item) => item.sequenceNo)];

      let nextSequenceNo = 1;
      while (allSequenceNos.includes(nextSequenceNo)) {
        nextSequenceNo++;
      }

      let duplicateIndex = uniqueArray.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
      const itemData = {
        pricingRule: pricingRule.mPricingrulesId,
        discountName: pricingRule.printedName,
        discountValue: discountInput,
        sequenceNo: duplicateIndex === -1 ? nextSequenceNo : totalLevelDiscounts[duplicateIndex]?.sequenceNo,
      };
      if (duplicateIndex === -1) {
        uniqueArray.push(itemData);
      } else {
        uniqueArray[duplicateIndex] = itemData;
      }

      let manualDiscountData = {
        totalLevelDiscount: uniqueArray,
        ...cart.manualDiscountData,
      };
      let obj = {
        ...cartObj,
        items: [...addedToCart],
        total: parseFloat(totalPrice.toFixed(precision)),
        tax: totalTax,
        discount: totalDiscounts,
        totalQty: totalItemsQty,
        roundOff: totalRoundOff,
        iscoupon: iscoupon ? iscoupon : false,
        couponInput: couponsData,
        totalBillDicount: iscoupon ? pricingRule.mPricingrulesId : false,
        totalDiscountFlag: true,
        manualDiscountData: manualDiscountData,
      };
      localStorage.setItem("cartObj", JSON.stringify(obj));
      if (!iscoupon) {
        setCart(obj);
      }
      return obj;
    } else {
      let couponsData = cart.couponInput ? [...cart.couponInput] : [];
      if (!couponsData.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
        couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
      }
      billCart.giftVoucherType = pricingRule.giftVoucherType;
      billCart.giftVoucherAmount = discountValue;
      billCart.iscoupon = cart.iscoupon ? cart.iscoupon : false;
      billCart.couponInput = couponsData;
      billCart.totalBillDicount = !iscoupon ? null : pricingRule.mPricingrulesId;
      setCart({ ...billCart });
      localStorage.setItem("cartObj", JSON.stringify({ ...billCart }));
      return { ...billCart };
    }
  } else {
    const cartItemsFiltered = billCart.items.filter((i) => i.nextRule === "Y" || i.nextRule === undefined);
    let salePricesTotal = 0;
    for (let i = 0; i < cartItemsFiltered.length; i += 1) {
      salePricesTotal += parseFloat(cartItemsFiltered[i].realPrice);
    }

    billCart.items.forEach((addedToCart, index) => {
      if (addedToCart.discountName === pricingRule.printedName && !addedToCart.isReturn) {
        const sp = parseFloat(addedToCart.realPrice);
        const mrp = parseFloat(sp) * addedToCart.weight;
        const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + addedToCart.taxRate / 100) : (mrp * addedToCart.taxRate) / 100;
        addedToCart.salePrice = sp;
        addedToCart.taxAmount = tax;
        addedToCart.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
        addedToCart.discount = 0;
        addedToCart.discountName = "";
        addedToCart.allDiscounts = [];
        billCart.items[index] = addedToCart;
      }
      // Process children if they exist
      if (addedToCart.children && Array.isArray(addedToCart.children)) {
        addedToCart.children.forEach((child, childIndex) => {
          if (child.discountName === pricingRule.printedName && !child.isReturn) {
            const sp = parseFloat(child.realPrice);
            const mrp = parseFloat(sp) * child.weight;
            const tax = taxIncludeFlag === "Y" ? mrp - mrp / (1 + child.taxRate / 100) : (mrp * child.taxRate) / 100;
            child.salePrice = sp;
            child.taxAmount = tax;
            child.nettotal = taxIncludeFlag === "Y" ? mrp : mrp + tax;
            child.discount = 0;
            child.discountName = "";
            child.allDiscounts = [];
            addedToCart.children[childIndex] = child;
          }
        });
        // Update parent's nettotal
        // let childrenNetTotal = addedToCart.children.reduce((sum, child) => sum + (child.nettotal || 0), 0);
        // addedToCart.nettotal = (addedToCart.nettotal || 0) + childrenNetTotal;
      }
    });

    billCart.mPricingruleId = pricingRule.mPricingrulesId;
    billCart.billDiscount = 0;

    const addedToCart = billCart.items;

    let totalTax = 0;
    let totalPrice = 0;
    let totalItemsQty = 0;
    let totalDiscounts = 0;
    for (let i = 0; i < addedToCart.length; i += 1) {
      if (addedToCart[i].isCanceled === "Y") continue;
      totalPrice += addedToCart[i].nettotal;
      totalItemsQty += addedToCart[i].weight;
      totalTax += addedToCart[i].taxAmount;
      totalDiscounts += addedToCart[i].discount;
      if (addedToCart[i].children && Array.isArray(addedToCart[i].children)) {
        addedToCart[i].children.forEach((child) => {
          totalPrice += child.nettotal || 0;
          totalItemsQty += child.weight || 0;
          totalTax += child.taxAmount || 0;
          totalDiscounts += child.discount || 0;
        });
      }
      addedToCart[i].key = i;
    }
    const roundOffValue = Math.round(totalPrice);
    const totalRoundOff = totalPrice - roundOffValue;
    let couponsData = cart?.couponInput?.length > 0 ? [...cart?.couponInput] : [];
    if (!couponsData?.some((coupon) => coupon.couponCode === couponInput) && couponInput !== undefined && couponInput !== null) {
      couponsData.push({ couponCode: couponInput, referenceId: uniqReferenceId, mPricingCouponId: mPricingCouponId, mPricingruleId: pricingRule.mPricingrulesId });
    }
    let uniqueArray = cart?.manualDiscountData?.totalLevelDiscount || [];

    let lineLevelDiscounts = cart?.manualDiscountData?.lineLevelDiscount || [];
    let totalLevelDiscounts = cart?.manualDiscountData?.totalLevelDiscount || [];

    let allSequenceNos = [...lineLevelDiscounts.map((item) => item.sequenceNo), ...totalLevelDiscounts.map((item) => item.sequenceNo)];

    let nextSequenceNo = 1;
    while (allSequenceNos.includes(nextSequenceNo)) {
      nextSequenceNo++;
    }

    let duplicateIndex = uniqueArray.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
    const itemData = {
      pricingRule: pricingRule.mPricingrulesId,
      discountName: pricingRule.printedName,
      discountValue: discountInput,
      sequenceNo: duplicateIndex === -1 ? nextSequenceNo : totalLevelDiscounts[duplicateIndex].sequenceNo,
    };
    if (duplicateIndex === -1) {
      uniqueArray.push(itemData);
    } else {
      uniqueArray[duplicateIndex] = itemData;
    }

    let manualDiscountData = {
      totalLevelDiscount: uniqueArray,
      ...cart.manualDiscountData,
    };
    let obj = {
      ...cartObj,
      items: [...addedToCart],
      total: parseFloat(totalPrice.toFixed(precision)),
      tax: totalTax,
      discount: totalDiscounts,
      totalQty: totalItemsQty,
      roundOff: totalRoundOff,
      iscoupon: iscoupon ? iscoupon : false,
      couponInput: couponsData,
      totalBillDicount: !iscoupon ? null : pricingRule.mPricingrulesId,
      discountType: "TD",
      totalDiscountFlag: true,
      manualDiscountData: manualDiscountData,
    };
    localStorage.setItem("cartObj", JSON.stringify(obj));
    if (!iscoupon) {
      setCart(obj);
    }
    return {
      ...cartObj,
      items: [...addedToCart],
      total: parseFloat(totalPrice.toFixed(precision)),
      tax: totalTax,
      discount: totalDiscounts,
      totalQty: totalItemsQty,
      roundOff: totalRoundOff,
      iscoupon: iscoupon ? iscoupon : false,
      couponInput: couponsData,
      discountType: "TD",
      totalBillDicount: !iscoupon ? null : pricingRule.mPricingrulesId,
      totalDiscountFlag: true,
      manualDiscountData: manualDiscountData,
    };
  }
};
